import React from 'react';
import { getPolyglot } from '../../../../../i18n';
import { Button } from '@mui/material';
import { DeleteIcon } from '../../../../../theme/icons';
import { useParams } from 'react-router-dom';
import { useGroupById } from '../../../../../redux/groups/hooks/useGroupById';
import { GroupType } from '../../../redux/group/model';
interface DeleteGroupButtonProps {
  openDeleteGroup: () => void;
}
export const DeleteStoreButton = ({
  openDeleteGroup,
}: DeleteGroupButtonProps) => {
  const params = useParams();
  const groupId = params.groupId ?? '';
  const polyglot = getPolyglot();
  const { data: group } = useGroupById(groupId);

  const isCompany =
    group?.attributes &&
    group?.attributes['BUSINESS_ROLE'] === GroupType.Company;
  return (
    <Button
      variant="text"
      color="error"
      startIcon={<DeleteIcon />}
      onClick={openDeleteGroup}
    >
      {isCompany
        ? polyglot.t('freshwatch.company.delete')
        : polyglot.t('freshwatch.store.delete')}
    </Button>
  );
};
